export enum USER_PROFILE_TYPE_ENUM {
  MYSS_MASTER = 1,
  MYSS_COMMERCIAL = 2,
  MYSS_MANAGER = 3,
  MYSS_FINANCIAL = 4,
  MYSS_FINANCIAL_ADMIN = 5,
}

export enum USER_PROFILE_TYPE_ENUM_MAPPER {
  'MyScanSource-Master' = USER_PROFILE_TYPE_ENUM.MYSS_MASTER,
  'MyScanSource-Commercial' = USER_PROFILE_TYPE_ENUM.MYSS_COMMERCIAL,
  'MyScanSource-Manager' = USER_PROFILE_TYPE_ENUM.MYSS_MANAGER,
  'MyScanSource-Financial' = USER_PROFILE_TYPE_ENUM.MYSS_FINANCIAL,
  'MyScanSource-Financial-Admin' = USER_PROFILE_TYPE_ENUM.MYSS_FINANCIAL_ADMIN,
}

export enum USER_STATUS_ENUM {
  INACTIVE = 0,
  ACTIVE = 1,
}
